type D = null | string | Date;

export function minDate(...dates: D[]): Date | null {
    return dates
        .filter((d): d is Date | string => !!d)
        .map(d => new Date(d))
        .filter(d => !Number.isNaN(d.getTime()))
        .reduce<Date | null>((min, current) => (!min || current < min ? current : min), null);
}
